<template>
  <b-card
    class="offer"
  >
    <table>
      <tr>
        <th>Proto</th>
        <td>{{offer.protoId | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>State</th>
        <td>{{offer.state | getOfferStateName}}</td>
      </tr>
      <tr>
        <th>Start</th>
        <td>{{offer.startStamp | getMomentStr}}</td>
      </tr>
      <tr>
        <th>Finish</th>
        <td>{{offer.finishStamp | getOptionalTextMomentStr('not finished')}}</td>
      </tr>
    </table>

    <template v-if="hasPayments">
      <p class="font-weight-bold mt-2">
        Billing services
      </p>
      <ul
        v-for="payment in offer.payments"
        :key="payment.sku"
        class="billing-services-list"
      >
        <li>{{payment.sku | getShortBillingServiceId}}</li>
      </ul>
    </template>

  </b-card>
</template>

<script>
export default {
  name: 'PlayerOfferPersonalSuperWhale',

  props: {
    offer: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasPayments() {
      if(this.offer === null) {
        return false;
      }
      if(!('payments' in this.offer)) {
        return false;
      }
      return this.offer.payments.length > 0;
    },
  },
};
</script>

<style scoped>
  .billing-services-list {
    list-style-type: none;
    padding-left: 0;
  }
</style>
